import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { CardUIProps } from './CardUI';
import { StyledCardUIContent } from './StyledCardUI';

const CardUIHeader = ({
  padding = '0.5rem',
  justifyContent = 'space-between',
  alignItems = 'center',
  alignContent = 'center',
  flexDirection = 'row',
  gap = '0',
  className = '',
  children,
  ...rest
}: PropsWithChildren<Omit<CardUIProps, 'backgroundColor'>>) => {
  return (
    <StyledCardUIContent
      padding={padding}
      justifyContent={justifyContent}
      alignItems={alignItems}
      alignContent={alignContent}
      flexDirection={flexDirection}
      gap={gap}
      className={classNames('sup-card-header', className)}
      {...rest}
    >
      {children}
    </StyledCardUIContent>
  );
};

export default CardUIHeader;
